const ascendingArray = ['ascending', 'asc'];
const descendingArray = ['descending', 'des'];

export default {
  data: () => ({ queryReady: false, storedQuery: {} }),
  props: {
    enableQueries: {
      type: Boolean,
      default: false
    },
    queryOptions: {
      type: Array,
      default: () => ['page', 'pageSize', 'search', 'sortColumn', 'sortDirection']
    },
  },
  computed: {
    queryFilters() {
      let newFilters = [];
      if (this.enableQueries) {
        const { query = {} } = this.$route;
        const { filters } = query;
        if (filters) {
          newFilters = JSON.parse(filters);
        };
      }
      return newFilters;
    },
  },
  created() {
    return Promise.resolve(this.enableQueries ? this.queryRestore() : null)
      .finally(() => { this.queryReady = true; });
  },
  watch: {
    rowData: {
      handler(current, previous) {
        const needsUpdate = this.dataMode === 'client' || (JSON.stringify(current) !== JSON.stringify(previous));
        return needsUpdate ? this.querySave() : null;
      }
    },
  },
  methods: {
    queryRestore() {
      if (this.enableQueries) {
        this.storedQuery = this.$route.query;
        const { page, pageSize, search } = this.$route.query;
        const column = this.$route.query.sortColumn || this.$route.query.column || '';
        const direction = this.$route.query.sortColumn || this.$route.query.direction || '';

        if (page) {
          const num = Number(page);
          this.internalPageNumber = num > 0 ? num - 1 : 0;
          this.storedQuery.page = num > 0 ? page : '1';
        }
        if (pageSize) {
          const num = Number(pageSize);
          this.internalItemsPerPage = num > 0 ? num : 15;
          this.storedQuery.pageSize = num;
        }
        if (search) this.searchText = search ? String(search).trim() : '';
        if (column) {
          const { columns = [] } = this;
          const exist = columns.find(({ id }) => String(id).toLowerCase() === String(column).toLowerCase());
          if (exist) this.internalSortColumn = column;
        }
        if (direction) {
          if (ascendingArray.includes(String(direction).toLowerCase())) {
            this.internalSortDirection = ascendingArray[0];
          }
          if (descendingArray.includes(String(direction).toLowerCase())) {
            this.internalSortDirection = descendingArray[0];
          }
        }
        if (this.queryFilters) this.activeFilters = this.queryFilters;
        if (this.dataMode === 'server') {
          return Promise.resolve(typeof this.tablePropsUpdated === 'function' && this.tablePropsUpdated())
            .catch(err => console.error(err.message))
        }
      }
    },
    querySave(data = this) {
      if (this.enableQueries) {
        const query = {};
        this.queryOptions.forEach((key) => {
          if (key === 'search') query[key] = data.searchText || undefined;
          else if (key === 'page') query[key] = String(data.internalPageNumber + 1) || undefined;
          else if (key === 'pageSize') query[key] = String(data.internalItemsPerPage) || undefined;
          else if (key === 'sortColumn') query.column = data.internalSortColumn || undefined;
          else if (key === 'sortDirection') query.direction = data.internalSortDirection || undefined;
          else query[key] = data[key] || undefined;
        })
        query.filters = (this.activeFilters.length) ? JSON.stringify(this.activeFilters) : undefined;
        try {
          const newQuery = { ...this.$route.query, ...query };
          this.storedQuery = newQuery;
          /** 
           * undefined properties are't included when pushed to $router.query 
           * guarantees consistent behavior for specific queries
          **/
          this.$router.push({ query: newQuery });
        } catch (error) {
          return null;
        }
      }
    },
    querySanitizeCurrentPage(opts = {}) {
      const { page = (this.internalPageNumber || 0), count = (this.pageCount || 0), toggleSave = false } = opts;
      /** IF internalPageNumber is out of bounds, sync with latest pageCount */
      if (this.enableQueries && page > 0 && page >= count) {
        this.internalPageNumber = count ? count - 1 : 0;
        toggleSave && this.querySave();
      }
    }
  },
};
